"use client";

import * as React from "react";
import { cn } from "./lib/utils";
import { Logo } from "./logo";

export interface HeaderProps {
  sticky?: boolean;
  logoHref?: string;
  onlyLogo?: boolean;
  noBackground?: boolean;
  noShadow?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export function Header({
  sticky = true,
  logoHref = "/",
  onlyLogo = false,
  noBackground = false,
  noShadow = false,
  children,
  className,
}: HeaderProps) {
  return (
    <div
      className={cn(
        "relative z-[400] bg-white shadow-[var(--iq-box-shadow-md)]",
        sticky && "lg:sticky lg:top-0",
        noBackground && "bg-transparent",
        noShadow && "shadow-none",
        className,
      )}
    >
      <header
        className={cn(
          "flex items-center justify-between max-w-[var(--iq-content-width)] h-[var(--iq-header-height)] mx-auto px-[20px] [&>*]:shrink-0",
          /* Pin font size so it doesn't inherit from .iq-base body */
          "text-sm xl:max-[1280px]:text-[12px]",
        )}
      >
        <div className="-mt-2">
          <div className="w-10 min-[400px]:w-[139px] h-[40px]">
            <Logo href={logoHref} iconOnlyOnMobile />
          </div>
        </div>
        {!onlyLogo && children}
      </header>
    </div>
  );
}

export interface HeaderNavProps {
  children?: React.ReactNode;
  className?: string;
}

export function HeaderMainNav({ children, className }: HeaderNavProps) {
  return (
    <nav
      className={cn(
        "hidden min-[1170px]:flex items-center ml-[20px] grow",
        /* gap: 5px base, 10px on large screens (matching original) */
        "gap-0 2xl:gap-[10px]",
        className,
      )}
    >
      {children}
    </nav>
  );
}
